import React from 'react';
import styled from 'styled-components';
import { Button, Modal } from 'semantic-ui-react';

const UpdateProductModal = ({
  title,
  onUpdate,
  onCancel,
  onСreate,
  isOpen,
  isLoadingDelete,
  warning,
  numberOfLinkedRecipes = 0,
}) => {
  return (
    <Modal style={{ alignSelf: 'center' }} open={isOpen} centered size="tiny">
      <Modal.Header style={{ textAlign: 'center' }}>
        <Name>{title}</Name>
        {warning && <Warning>{warning}</Warning>}
      </Modal.Header>
      <Modal.Content>
        <ButtonsWrapper>
          <Buttons>
            <Button negative style={{ width: '100%' }} onClick={onCancel}>
              Отмена
            </Button>
          </Buttons>
          <Buttons>
            <Button
              style={{ width: '100%' }}
              onClick={() => onUpdate()}
              color="yellow"
              loading={isLoadingDelete}
              disabled={numberOfLinkedRecipes > 0}
            >
              Обновить
            </Button>
          </Buttons>
          <Buttons>
            <Button
              style={{ width: '100%' }}
              onClick={() => onСreate()}
              positive
              loading={isLoadingDelete}
              disabled={numberOfLinkedRecipes > 0}
            >
              Создать новый
            </Button>
          </Buttons>
        </ButtonsWrapper>
      </Modal.Content>
    </Modal>
  );
};

export default UpdateProductModal;

const Name = styled.p`
  font-size: 20px;
  align-items: center;
  margin: 0;
  word-break: break-all;
`;

const Warning = styled.p`
  font-size: 12px;
  align-items: center;
  color: red;
`;

const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
`;
const Buttons = styled.div`
  width: 150px;
  height: 40px;
`;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/ProductUpdateModal/index.js